import React from 'react';
import Imgix from 'react-imgix';
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import styled from 'styled-components';
import { BodyThree } from '../../../../../../styles/theme/default/typography';
import { getImgixUrl, getName, getPrice } from '../../../../../../utils/helper';

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
  align-items: center;

  .image-wrapper-side {
    min-width: 140px;
    margin-right: 16px;
  }

  .bundle-product-name-link {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
    color: ${({ theme }) => theme.colors.charcoal};
    text-decoration: underline;
  }

  .price-name {
    display: grid;
    grid-template-columns: 1fr 60px;
  }

  .price {
    text-align: end;
  }

  .product-name-side {
    width: 100%;
  }

  @media (max-width: 992px) {
    margin-bottom: 14px;

    .product-name-side {
      /* flex: 1 0 70%; */
    }

    .image-wrapper-side {
      min-width: auto;
      flex: 1 0 30%;
    }
  }
`;

function BundleProduct({ bundleProduct, setChangeFeaturedFabrics }) {
  const { name, slug, fabric, images, price, frame } = bundleProduct.product;

  const image = images[0];

  const url = `/products/${slug}`;

  const getFabricFullName = () => {
    return `in ${fabric.name}${
      fabric.collaborator ? ` by ${fabric.collaborator.name}` : ''
    }`;
  };

  const fabricFullName = getFabricFullName();

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  const productName = `${getName(name).trim()}${
    [1, 30, 31].includes(parseInt(frame.primarySubcategory.category_id))
      ? `, ${frame?.size.name}`
      : ''
  }`;

  return (
    <Wrapper>
      <div className="image-wrapper-side">
        <ImageContainer>
          <Link
            to={url}
            onClick={() => {
              scrollToTop();
              setChangeFeaturedFabrics(true);
            }}
          >
            <Imgix
              className="bundle-product-image"
              imgixParams={{ auto: 'compress,format' }}
              sizes="(min-width: 993px) 140px, 25vw"
              src={getImgixUrl(image.path)}
              htmlAttributes={{
                alt: image.name
              }}
            />
          </Link>
        </ImageContainer>
      </div>

      <div className="product-name-side">
        <div className="price-name">
          <div className="link-supplier-qty-container">
            <Link
              to={url}
              onClick={() => {
                scrollToTop();
                setChangeFeaturedFabrics(true);
              }}
              className="bundle-product-name-link"
            >
              {getName(productName)}
            </Link>{' '}
            <BodyThree as="span" className="supplier-quantity">
              ({bundleProduct.quantity})
            </BodyThree>
          </div>

          <BodyThree className="price">
            ${getPrice(price * bundleProduct.quantity)}
          </BodyThree>
        </div>
        {fabric && <BodyThree color="#6C6C6C">{fabricFullName}</BodyThree>}
      </div>
    </Wrapper>
  );
}

export default BundleProduct;

const ImageContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-bottom: 56.25%;
  a {
    position: absolute !important;
    top: 0;
    left: 0;
    background: #f7f9fa;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .bundle-product-image {
      position: absolute;
      max-width: 100%;
      max-height: 100%;
      width: auto;
    }
  }

  @media (max-width: 992px) {
    padding-bottom: 100%;
  }
`;
